export const ACTIVE = "active";
export const LOST = "lost";
export const BROKEN = "broken";
